import animations from './elements/animations';
import menu from './elements/menu';
import burger from './elements/burger';
import subnavigation from './elements/subnavigation';
import carousel from './elements/carousel';
import about from './elements/about';
import slider from './elements/slider';
import video from './elements/video';
import map from './elements/map';
import calendar from './elements/calendar';
import contact from './elements/contact';
import form from './elements/form';
import scrollerindication from './elements/scrollerindication';
import './fslightbox';

document.addEventListener('DOMContentLoaded', e => {
    if (window.location.hash === '#historia') {
        about('historia');
        slider('#slider-historia');
    } else {
        about('gospodarstwo');
        slider('#slider-gospodarstwo');
    }
    animations();
    menu();
    burger();
    subnavigation();
    carousel();
    video();
    map();
    calendar();
    contact();
    form();
    scrollerindication();
});
